import Phaser from 'phaser';

import { createGameLevels } from './GameFunctions';
import { gameAssets } from './LevelsConfig';

export default class BaseSoupGameScene extends Phaser.Scene {

    //define currentStep as a property of the scene
    currentStep = null;

    create() {
        console.log('BaseSoupGameScene create');

        // Initialize data if needed
        this.data.set('currentStep', 0);

        // Add the event listener
        this.game.events.on('changeStep', this.handleStepChange, this);

        // //add listen for autoTrackProgressEvent on the window
        // window.addEventListener('autoTrackProgressEvent', (event) => {
        //     console.log('autoTrackProgressEvent', event.detail,
        //         this.currentStepData
        //     );

        //     if (this.currentStepData?.audioTimeTriggers){
                
        //     }
        // });
    }

    // //scene started
    init() {
        console.log('BaseSoupGameScene init');
    }

    handleStepChange(currentLevel, currentLevelData, currentStep, currentStepData) {
        console.log('handleStepChange:', currentLevel, currentLevelData, currentStep, currentStepData);


        //check if this.currentStepData.scene is different new currentStepData.scene. If it is we need to change scenes
        let currentScene = this.currentStepData?.scene;
        let nextStepScene = currentStepData?.scene;

        //if currentScene is null, set it to the nextStepScene
        if (!currentScene) {
            currentScene = "KitchenScene";//1st scene
        }

        // React to the step change
        this.currentLevel = currentLevel;
        this.currentLevelData = currentLevelData;
        this.currentStep = currentStep;
        this.currentStepData = currentStepData;

        if (currentScene !== nextStepScene || window.skippingSteps) {
            window.skippingSteps = false;
            console.log("changing scenes", currentScene, nextStepScene);
            this.endScene(currentScene, nextStepScene);//end this scene and start the next scene
        }

        /**
         * execute any triggers for this step
         * 
         * example trigger: "triggers":[
            {
              "target": "sink",
              "action": "wiggle"
            }
          ]
         */
        if (currentStepData?.triggers) {
            currentStepData.triggers.forEach(trigger => {
                let gameObject = this.getGameObjectByName(trigger.target);

                //no game object found so exit
                if(!gameObject){
                    return;
                }


                if (trigger.action === "wiggle") {
                    //let gameObject = this.getGameObjectByName(trigger.target);
                    if (gameObject) {
                        this.createWiggleAnimation(gameObject);
                    }
                }

                //if game object is a spine use the action to play the animation
                if (gameObject?.constructor?.name === 'SpineGameObject') {
                    gameObject.alpha = 1;
                    gameObject.play(trigger.action);
                }
            });
        }

        //if current step has effectAudioClipUrl then play that audio once
        if (currentStepData?.effectAudioClip) {
            this.sound.play(currentStepData?.effectAudioClip, { volume: 0.1});
        }
    }

    /**
     * runs any events to shutdown this scene and then starts the next scene
     */
    endScene(currentScene, nextSceneName) {
        try {
            //const allAlphaZero = this.gameObjects?.every(item => item.alpha === 0);
            const allAlphaZero = this.gameObjects.filter(item => item._alpha === 0 && item.constructor?.name !== 'SpineGameObject');
            
            if (this.gameObjects?.length === 0 || allAlphaZero.length == 0) {
                try {
                    this.scene.stop(currentScene);
                } catch (error) {
                    console.error("error ending scene", error);
                }
                try {
                    this.scene.start(nextSceneName); // Start the next scene after all tweens are complete
                } catch (error) {
                    console.error("error starting scene", error);
                }
            } else {
                const filteredObjects = this.gameObjects.filter(gameObject => gameObject?.constructor.name !== 'SpineGameObject' && gameObject._alpha > 0);

                if (filteredObjects.length === 0) {
                    try {
                        this.scene.stop(currentScene);
                    } catch (error) {
                        console.error("error ending scene", error);
                    }
                    try {
                        this.scene.start(nextSceneName); // Start the next scene after all tweens are complete
                    } catch (error) {
                        console.error("error starting scene", error);
                    }
                }else{
                    // Fade out and move to the next scene
                    //console.log("object fade tween 1");
                    this.tweens.add({
                        targets: filteredObjects, // Replace with the items you want to fade out
                        alpha: { from: 1, to: 0 },
                        duration: 500, // Duration in milliseconds
                        ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too
                        onComplete: () => {
                            setTimeout(() => {
                                try {
                                    this.scene.stop(currentScene);
                                } catch (error) {
                                    console.error("error ending scene", error);
                                }
                                try {
                                    this.scene.start(nextSceneName); // Start the next scene after all tweens are complete
                                } catch (error) {
                                    console.error("error starting scene", error);
                                }
                            }, 1000);
                        },
                    });
                }

                
            }
        } catch (error) {
            console.error("error ending scene", error);

            try {
                this.scene.stop(currentScene);
            } catch (error) {
                console.error("error ending scene", error);
            }
            try {
                this.scene.start(nextSceneName); // Start the next scene after all tweens are complete
            } catch (error) {
                console.error("error starting scene", error);
            }
        }
    }

    // Don't forget to remove the listener when the scene shuts down
    shutdown() {
        console.log('BaseSoupGameScene shutdown');
        this.game.events.off('changeStep', this.handleStepChange, this);
        
        // Stop all active tweens
        this.tweens.killAll();



        //loop through all game objects and call destroy if it exists
        //also call this.tweens.killTweensOf(item) if it exists
        this.gameObjects.forEach(item => {
            if (this.tweens.killTweensOf) {
                this.tweens.killTweensOf(item);
            }

            if (item.destroy) {
                item.destroy();
            }
        });
    }

    destroy() {
        // Optional: Also stop tweens in the destroy method if needed
        this.tweens.killAll();
    }

    //method to identify the object in the current step
    //we will pass in the name like "pot" and it will return the object
    getGameObjectByName(name) {
        try {
            return this.gameObjects.find(item => item.id === name);
        } catch (error) {
            console.error("error getting game object by name", error);
        }
        return null;
    }

    /**
     * Creates a wiggle animation for a given game object.
     * @param {Phaser.GameObjects.GameObject} gameObject - The game object to animate.
     */
    createWiggleAnimation(gameObject) {
        try {
            // Ensure the gameObject is a valid Phaser object
            if (!gameObject || !(gameObject instanceof Phaser.GameObjects.GameObject)) {
                throw new Error('Invalid game object for wiggle animation');
            }

            if (this.isTweenRunning(gameObject)) {
                return;
            }

            // Store the original position, origin, and scale
            gameObject.originalX = gameObject.x;
            gameObject.originalY = gameObject.y;
            gameObject.originalOriginX = gameObject.originX;
            gameObject.originalOriginY = gameObject.originY;
            gameObject.originalScaleX = gameObject.scaleX;
            gameObject.originalScaleY = gameObject.scaleY;

            // Calculate the new position based on the new origin
            const halfWidth = gameObject.displayWidth * 0.5;
            const halfHeight = gameObject.displayHeight * 0.5;
            gameObject.x += halfWidth;
            gameObject.y += halfHeight;

            // Set the origin to the center
            gameObject.setOrigin(0.5, 0.5);

            // Define the scale adjustment value
            const scaleAdjustment = 0.05; // Adjust this value to change the scale adjustment

            // Create the tween for rotation and scaling
            gameObject.scene.tweens.add({
                targets: gameObject,
                angle: { from: gameObject.angle - 10, to: gameObject.angle + 10 }, // Adjust the value for the amount of rocking
                scaleX: { from: gameObject.scaleX, to: gameObject.scaleX + scaleAdjustment }, // Increase scale by the adjustment value
                scaleY: { from: gameObject.scaleY, to: gameObject.scaleY + scaleAdjustment }, // Increase scale by the adjustment value
                yoyo: true, // Makes the tween go back to its original position and scale
                repeat: 3, // Repeat once
                ease: 'Sine.easeInOut', // This easing creates a smooth wiggle effect
                duration: 150, // Duration of one complete wiggle in milliseconds
                onComplete: function () {
                    //example of itemConfig
                    //gameObject.itemConfig = { media: 'counter', x: -177, y: 569, width: 7800, height: 1288 },

                    // Reset to original position, angle, scale, and origin using the itemConfig
                    gameObject.x = gameObject.itemConfig.x;
                    gameObject.y = gameObject.itemConfig.y;
                    gameObject.angle = 0;
                    gameObject.scaleX = gameObject.originalScaleX;
                    gameObject.scaleY = gameObject.originalScaleY;
                    gameObject.setOrigin(0, 0);


                    // // Reset to original position, angle, scale, and origin
                    // gameObject.x = gameObject.originalX;
                    // gameObject.y = gameObject.originalY;
                    // gameObject.angle = 0;
                    // gameObject.scaleX = gameObject.originalScaleX;
                    // gameObject.scaleY = gameObject.originalScaleY;
                    // gameObject.setOrigin(gameObject.originalOriginX, gameObject.originalOriginY);

                    //remove the tween from the tween manager
                    gameObject.scene.tweens.remove(this);
                }
            });
        } catch (error) {
            console.error('An error occurred during the wiggle animation:', error);
        }
    }

    /**
     * function to check if tween is already running
     */
    isTweenRunning(gameObject) {
        try {
            // Ensure the gameObject is a valid Phaser object
            if (!gameObject || !(gameObject instanceof Phaser.GameObjects.GameObject)) {
                throw new Error('Invalid game object for wiggle animation');
            }

            //check if tween is already running
            let tween = this.tweens.getTweensOf(gameObject);
            if (tween && tween.length > 0) {
                return true;
            }
        } catch (error) {
            console.error('An error occurred during the wiggle animation:', error);
        }
        return false;
    }

    //function to set the visibility of the gameObjects based on the subSectionID
    handleGameObjectSubSectionVisibility() {
        let currentStepData = this.game?.currentState?.currentStepData;
        this.gameObjects.forEach(gameObject => {
            let subSectionID = gameObject?.itemConfig?.subSectionID;
            if (subSectionID) {
                //if the subSectionID matches or contains the currentStepData.subSectionID, set the visibility to true otherwise set it to false
                if (subSectionID === currentStepData?.subSectionID || subSectionID?.includes(currentStepData?.subSectionID)){
                    if (gameObject?.itemConfig?.fade){
                        console.log("object fade tween 2");
                        this.tweens.add({
                            targets: gameObject,
                            alpha: { from: 0, to: 1 },
                            duration: 1000, // Duration in milliseconds
                            ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too,
                            onComplete: () => {
                                gameObject.setVisible(true);
                                gameObject.alpha = 1;
                            }
                        });
                    }else{
                        //if the visibility is not set to true, set it to true and if the alpha is 0, set it to 1
                        if (!gameObject.visible) {
                            //gameObject.setVisible(true);
                            //this was removed because it caused a bug in the game
                            //gameObject.alpha = 1;
                            //fade in the object
                            //console.log("object fade tween 3");
                            if (currentStepData?.subSectionID !== "reviewB") {
                                gameObject.setVisible(true);
                                this.tweens.add({
                                    targets: gameObject,
                                    alpha: { from: 0, to: 1 },
                                    duration: 1000, // Duration in milliseconds
                                    ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too,
                                    onComplete: () => {
                                        gameObject.alpha = 1;
                                    }
                                });
                            }else{
                                gameObject.setVisible(true);
                                gameObject.alpha = 1;
                            }
                            
                        }
                    }
                } else {
                    if(gameObject?.itemConfig?.fade){
                        console.log("object fade tween 4");
                        this.tweens.add({
                            targets: gameObject,
                            alpha: { from: 1, to: 0 },
                            duration: 1000, // Duration in milliseconds
                            ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too,
                            onComplete: () => {
                                gameObject.setVisible(false);
                                gameObject.alpha = 0;
                            }
                        });
                    }else{
                        if (gameObject.visible) {
                            gameObject.setVisible(false);
                            //this tween caused a bug in the game so we removed it.
                            //gameObject.alpha = 0;
                            //fade out the object
                            //console.log("object fade tween 5", gameObject);
                            // this.tweens.add({
                            //     targets: gameObject,
                            //     alpha: { from: 1, to: 0 },
                            //     duration: 1000, // Duration in milliseconds
                            //     ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too,
                            //     onComplete: () => {
                            //         gameObject.alpha = 0;
                            //     }
                            // });
                        }
                    }
                }
            }

            //if object has hideOnSubSection (array) then we hide it if the subSectionID is in the array
            if (gameObject?.itemConfig?.hideOnSubSection?.includes(subSectionID)){
                if(gameObject?.itemConfig?.fade){
                    console.log("object fade tween 6");
                    this.tweens.add({
                        targets: gameObject,
                        alpha: { from: 1, to: 0 },
                        duration: 1000, // Duration in milliseconds
                        ease: 'Linear', // 'Linear' for a steady fade; you can try other easing functions too,
                        onComplete: () => {
                            gameObject.setVisible(false);
                            gameObject.alpha = 0;
                        }
                    });
                }
            }
        });
    }

    preload() {

        //lets preload the audio
        this.load.audio('greatJob', 'audio/great-job.mp3');
        this.load.audio('congrats', 'audio/congrats.mp3');

        // Load your assets here


        // //load jumping pot
        // this.load.spineJson("pot-json", "media/animations/v2_spine/potExample.json");
        // this.load.spineAtlas("pot-atlas", "media/animations/v2_spine/skeletons.atlas");

        // //load diced veggies
        // this.load.spineJson("chopping-json", "media/animations/Final_SpineDeliverables/choppingSpine.json");
        // this.load.spineAtlas("chopping-atlas", "media/animations/Final_SpineDeliverables/choppingSpine.atlas");

        // //sprinkle
        // this.load.spineJson("sprinkleSpine-json", "media/animations/Final_SpineDeliverables/sprinkleSpine.json");
        // this.load.spineAtlas("sprinkleSpine-atlas", "media/animations/Final_SpineDeliverables/sprinkleSpine.atlas");

        //iterate over the keys from gameAssets.media.images
        // Object.keys(gameAssets.media.images).forEach(key => {
        //     let value = gameAssets.media.images[key];
        //     this.load.image(key, value);
        // });

        // // Set texture filtering
        // // this.load.on('filecomplete', (key, type, data) => {
        // //     if (type === 'image') {
        // //         this.textures.get(key).setFilter(Phaser.Textures.FilterMode.NEAREST);
        // //     }
        // // });

        //javascript emit so the react app can listen for the event
        this.game.events.emit('phaserScenePreloadStart');
    }

    loadImage(key) {
        let self = this;
        return new Promise((resolve, reject) => {
            if (self.textures.exists(key)) {
                resolve();
            } else {
                let value = gameAssets.media.images[key];
                self.load.image(key, value);
                self.load.once('complete', () => {
                    try {
                        self.textures.addBase64(key, value);
                    } catch (error) {
                        console.error("error adding base64", error);
                    }
                    
                    resolve();
                }, self);
                self.load.once('loaderror', () => {
                    reject(new Error(`Failed to load image: ${key}`));
                    console.error(`Failed to load image: ${key}`);
                }, self);
                self.load.start();
            }
        });
    }

}